import { render, staticRenderFns } from "./DealsGroupList.vue?vue&type=template&id=031c0819&scoped=true&"
import script from "./DealsGroupList.vue?vue&type=script&lang=js&"
export * from "./DealsGroupList.vue?vue&type=script&lang=js&"
import style0 from "./DealsGroupList.vue?vue&type=style&index=0&id=031c0819&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c0819",
  null
  
)

export default component.exports